import { banco } from '../db/banco'

export function proximaSequencia(numerosExistentes: string[], ano: number): string {
  const prefixo = `${ano}-`
  let maior = 0
  for (const numero of numerosExistentes) {
    if (!numero.startsWith(prefixo)) continue
    const sequencia = Number(numero.slice(prefixo.length))
    if (Number.isInteger(sequencia) && sequencia > maior) maior = sequencia
  }
  return `${prefixo}${String(maior + 1).padStart(4, '0')}`
}

export async function proximoNumeroPedido(): Promise<string> {
  const numeros = (await banco.pedidos.toArray()).map((p) => p.numero)
  return proximaSequencia(numeros, new Date().getFullYear())
}

export function letraDoIndice(indice: number): string {
  let letra = ''
  let n = indice
  do {
    letra = String.fromCharCode(65 + (n % 26)) + letra
    n = Math.floor(n / 26) - 1
  } while (n >= 0)
  return letra
}

// Inversa de letraDoIndice (base 26 bijetiva): 'A'->0, 'Z'->25, 'AA'->26.
export function indiceDaLetra(letra: string): number {
  let indice = 0
  for (const caractere of letra) {
    indice = indice * 26 + (caractere.charCodeAt(0) - 65 + 1)
  }
  return indice - 1
}
